import { Controller } from "@hotwired/stimulus";

// some links are "current": (i.e. the current page you are on)
// other links are non-current (i.e. point to a page that you are not currently on)

export default class extends Controller {

    static classes = ["current"];
    static targets = ["link"];

    connect() {
        this.setActiveMenu(window.location.href);
    }

    menuClicked(event) {
        let href = event.srcElement.href;
        this.setActiveMenu(href);
    }

    setActiveMenu(href) {
        if (this.isApplicable(href)) {
            this.linkTargets.forEach(link => {
                if (href === link.href) {
                    link.classList.add(this.currentClasses);
                } else {
                    link.classList.remove(this.currentClasses);
                }
            });
        }
    }

    isApplicable(href) {
        return this.linkTargets.some(link => {
            return href === link.href;
        });
    }
}
